// Roll up some of the long form xstate types into simpler names:

import { SnapshotFrom } from 'xstate'
import { player_state_machine } from './Player_State_Machine'

export type Player_Machine_Snapshot = SnapshotFrom<typeof player_state_machine>

export enum Websocket_Event_Names {
	create_new_server = 'create_new_server',
	connect_websocket = 'connect_websocket',
	websocket_opened = 'websocket_opened',
	websocket_closed = 'websocket_closed',
	websocket_error = 'websocket_error',
	client_request_disconnect = 'client_request_disconnect',
}

export interface Notifier {
	info(message: string): void
	error(message: string): void
}